import { create } from 'zustand';

/**
 * Inbox Store — lightweight UI state.
 * Die Items selbst werden via react-query geladen, hier nur Filter + Selection + Counts.
 */
const useInboxStore = create((set, get) => ({
  // Filter-State
  filters: {
    status: 'unread',      // 'unread' | 'all' | 'active' | 'done' | 'dismissed'
    category: null,        // null | 'lead' | 'alert' | 'approval' | 'opportunity' | 'info'
    priority: null,        // null | 'urgent' | 'high' | 'normal' | 'low'
    sourceModule: null,    // null | 'content' | 'keywords' | ...
    q: ''
  },

  // Selection fuer Bulk-Actions
  selectedIds: new Set(),
  activeId: null, // fuer Detail-Drawer

  // Live unread-count (von SSE aktualisiert)
  unreadCount: 0,

  setFilter: (key, value) =>
    set((state) => ({ filters: { ...state.filters, [key]: value } })),

  setFilters: (filters) =>
    set((state) => ({ filters: { ...state.filters, ...filters } })),

  resetFilters: () =>
    set({
      filters: { status: 'unread', category: null, priority: null, sourceModule: null, q: '' }
    }),

  toggleSelected: (id) => {
    const next = new Set(get().selectedIds);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    set({ selectedIds: next });
  },

  selectAll: (ids) => set({ selectedIds: new Set(ids) }),
  clearSelection: () => set({ selectedIds: new Set() }),

  setActiveId: (id) => set({ activeId: id }),
  closeDetail: () => set({ activeId: null }),

  setUnreadCount: (count) => set({ unreadCount: count }),
  incrementUnread: () => set((state) => ({ unreadCount: state.unreadCount + 1 }))
}));

export default useInboxStore;
